// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6380cd3f","422":"711819e5","455":"df3d3aab"}[chunkId] + ".chunk.js";
};